export default function Django_Delete_Members() {
  return <div>Django_Delete_Members Component</div>;
}
